import { ApplicationEnvironment } from '../../entities/catalog/application.environment';
import { EnvironmentConfiguration } from './environment.configuration';

export const environmentEdge = {
  locale: 'en-AU',
  production: false,
  api: '/api',
  domain: 'workbuddy.run',
  auth: {
    local: {
      callbackUrl: 'http://{0}:4000/callback',
    }
  },
  jms: {
    loginHref: 'https://id.workbuddy.run',
    logoutHref: 'https://id.workbuddy.run/logout',
    captcha: '6LfQ01oUAAAAAFfG2a8ZR509QugrxclKGsINjcKN',
    captchaSecret: '6LfQ01oUAAAAAFfjjGsSDeMfCc9ZPTAMswBcBh8y',
  },
  sentry: {
    dsn: '',
    name: '',
    release: '',
    environment: ''
  },
  environment: ApplicationEnvironment.Edge
} as EnvironmentConfiguration;
